import { useLocale, useTranslations } from 'next-intl';
import type { Locale } from '~/i18n/i18n-config';
import { api } from '~/libs/api';
import { getRefetchableBlueprintId, resolveTripDisplayTitle } from '~/utils/tripTitle';
import useJourneyData from './useJourneyData';

// See resolveTripDisplayTitle (utils/tripTitle.ts) for why this can't just trust journey.title.
// This hook re-fetches the Blueprint title client-side (the only piece resolveTripDisplayTitle
// can't do itself); generateMetadata does the equivalent fetch server-side for the page <title>.
export function useResolvedTripTitle(journey: Parameters<typeof resolveTripDisplayTitle>[2]) {
  const t = useTranslations();
  const locale = useLocale() as Locale;

  const blueprintId = getRefetchableBlueprintId(journey);
  const { data: blueprintTitle } = api.cms.blueprintTitle.useQuery(
    { blueprintId: blueprintId ?? '', locale },
    { enabled: !!blueprintId }
  );

  return resolveTripDisplayTitle(t, locale, journey, blueprintTitle?.title);
}

export default function useTripDisplayTitle() {
  return useResolvedTripTitle(useJourneyData());
}
